"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createErrorExportText = createErrorExportText;
function createErrorExportText(data) {
  return JSON.stringify(data, null, 2);
}
